import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

export function Hero() {
    return (
        <section className="relative pt-20 pb-24">
            <div className="mx-auto max-w-6xl px-4">
                <div className="max-w-3xl">
                    <h1 className="text-4xl font-bold tracking-tight sm:text-5xl">Run world-class technical interviews with collaborative AI assistance.</h1>
                    <p className="mt-6 text-lg text-muted-foreground max-w-2xl">Arrowise streamlines preparation, execution, and evaluation so you can focus on people—not logistics.</p>
                    <p className="mt-4 text-sm italic text-muted-foreground max-w-2xl">"An arrow's flight is only motion; human intent turns motion into meaning."</p>
                    <div className="mt-8 flex flex-wrap gap-4">
                        <Button asChild size="lg"><Link to="/register">Get Started</Link></Button>
                        <Button asChild variant="outline" size="lg"><Link to="/login">I already have an account</Link></Button>
                    </div>
                </div>
            </div>
            <div className="pointer-events-none absolute inset-0 -z-10 bg-[radial-gradient(circle_at_20%_20%,oklch(0.929_0.013_255.508/.35),transparent_60%)] dark:bg-[radial-gradient(circle_at_20%_20%,oklch(0.551_0.027_264.364/.35),transparent_60%)]" />
        </section>
    );
}
